import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { authProfile } from 'redux/auth/selectors';
import SITELINKS from 'constants/sitelinks';

/**
 * Ruta visible sólo para los roles indicados. El menú ya oculta los ítems que
 * no corresponden; esto cubre el caso de entrar por URL directa.
 *
 * ponytail: esto es UX, no seguridad. El backend sigue siendo quien autoriza.
 */
const RoleRoute = ({ roles, ...routeProps }) => {
  const profile = useSelector(authProfile);
  if (!profile) {
    return null;
  }
  if (!roles.includes(profile.userRoleID)) {
    return <Redirect to={SITELINKS.loggedHome} />;
  }
  return <Route {...routeProps} />;
};

RoleRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default RoleRoute;
